/**
 * MODULE: domain/pages/frontend/components/CommentMentionContent.tsx
 * PURPOSE: Render page comment text with styled @mention chips
 */

import { parseCommentContent } from '../utils/commentMentionUtils';

type Props = {
  content: string;
};

export function CommentMentionContent({ content }: Props) {
  const parts = parseCommentContent(content);

  return (
    <span className="whitespace-pre-wrap text-sm text-gray-800 dark:text-gray-200">
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <span key={`text-${index}`}>{part.value}</span>;
        }
        return (
          <span
            key={`mention-${part.userId}-${index}`}
            className="mx-0.5 inline-flex rounded bg-blue-50 px-1.5 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-200"
            data-testid={`pages-comment-mention-${part.userId}`}
          >
            @{part.label}
          </span>
        );
      })}
    </span>
  );
}
